import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { WeekdayCandidates } from '@/features/weekday-candidates'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  filter: z.string().optional().catch(''),
  activityMode: z.enum(['ACTIVE', 'NOT_LOOKING_OUT', 'STRICTLY_NOT_LOOKING_OUT', 'NO_CLUE']).optional().catch(undefined),
  hasEmail: z.boolean().optional().catch(undefined),
  hasPhone: z.boolean().optional().catch(undefined),
  dataTier: z.enum(['premium', 'basic', 'minimal']).optional().catch(undefined),
  sortBy: z.string().optional().catch(undefined),
  sortDir: z.enum(['asc', 'desc']).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/weekday-candidates/')({
  validateSearch: searchSchema,
  component: WeekdayCandidates,
})
